import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

const HeroSection = () => {
  const navigate=useNavigate()
  const [keyword, setKeyword] = useState('');
  const [location, setLocation] = useState('');
  const [category, setCategory] = useState('');
  const [error, setError] = useState('');

  const fillRef=useRef(null);
  const pageRef=useRef(null);
  const locUrl=useLocation();

  useEffect(() => {
    if(locUrl.state?.searchJob){
      pageRef.current.scrollIntoView({behavior:"smooth"});
      window.scrollBy({top:65,behavior:"smooth"});
      
      fillRef.current.focus();
    }
  }, [locUrl])
  

  const handleSearch = (e) => {
    e.preventDefault();
    if (keyword.length < 3 && location.length < 3) {
      setError("Minimum 3 characters required");
      return;
    }
    if(!keyword.trim() && !location.trim()){
      setError('keyword or location is mandatory.');
      return;
    }
    setError();
    navigate(`/jobs?keyword=${encodeURIComponent(keyword)}&location=${encodeURIComponent(location)}`);
  };
  return (
    <div className="hero-section overflow-hidden" >
    <div className="hero-single" ref={pageRef}>
      <div className="container" >
        <div className="row align-items-center" >
          <div className="col-lg-6 col-xl-6">
            <div className="hero-content">
              <h6 className="hero-sub-title" >
                🚀<CountUp start={0} end={25000} duration={1} />+ 
                Live Jobs at Your Fingertips
              </h6>
              <h1 className="hero-title">
              Find Your <span>Dream Job</span> Effortlessly with Skilletix
              </h1>
              <p>
              At Skilletix, we simplify job hunting by connecting you with top opportunities in tech, design, marketing, and beyond. Whether you're an experienced professional or just starting out, your dream job is just a search away!
              </p>
              <div className="search-form">
                  <div className="search-form-wrapper">
                    <form onSubmit={handleSearch}>
                      <div className="row justify-content-center align-items-stretch g-2">
                        {/* Keyword Input */}
                        <div className="col-md-5 px-1">
                          <div className="form-group form-group-search">
                            <div className="form-group-icon">
                              <input
                              ref={fillRef}
                                type="text"
                                className="form-control"
                                placeholder="Type Keyword..."
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                              />
                              <i className="fe-search" />
                            </div>
                          </div>
                        </div>

                        {/* Location Text Input */}
                        <div className="col-md-4 px-1">
                          <div className="form-group form-group-search">
                            <div className="form-group-icon">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Location"
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                              />
                              <i className="fe-map-pin" />
                            </div>
                          </div>
                        </div>

                        {/* Category Text Input 
                        <div className="col-md-3 px-0">
                          <div className="form-group form-group-search">
                            <div className="form-group-icon">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Category"
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                              />
                              <i className="fe-briefcase" />
                            </div>
                          </div>
                        </div>*/}

                        {/* Search Button */}
                        <div className="col-md-3 px-1">
                          <div className="form-group form-group-search d-grid h-100">
                            <button type="submit" className="btn theme-btn w-100">
                              <span className="fe-search" />
                              Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/* Error Message */}
                    {error && (
                    <div className="text-danger mt-2 text-center small fw-semibold">
                      {error}
                    </div>
                    )}
                  </div>
                <div className="popular-search">
                  <span>🔥Trending Search:</span><Link to={"/jobs?keyword=Software Engineer"}>Software Engineer</Link>,<Link to={"/jobs?keyword=MERN Stack Developer"}>MERN Stack Developer</Link>,<Link to={"/jobs?keyword=Designer"}>Designer</Link>
                </div>
                <div className="hero-info-box">
                  <div className="hero-info-img">
                    <span>
                      <img 
                      loading="lazy"
                      role="presentation"
                      decoding="async"
                      fetchpriority="high"src="assets/img/account/01.jpg" alt="" />
                    </span>
                    <span>
                      <img 
                      loading="lazy"
                      role="presentation"
                      decoding="async"
                      fetchpriority="high"src="assets/img/account/02.jpg" alt="" />
                    </span>
                    <span>
                      <img 
                      loading="lazy"
                      role="presentation"
                      decoding="async"
                      fetchpriority="high"src="assets/img/account/03.jpg" alt="" />
                    </span>
                    <span>
                      <img 
                      loading="lazy"
                      role="presentation"
                      decoding="async"
                      fetchpriority="high"src="assets/img/account/04.jpg" alt="" />
                    </span>
                    <span>
                      <img 
                      loading="lazy"
                      role="presentation"
                      decoding="async"
                      fetchpriority="high"src="assets/img/account/05.jpg" alt="" />
                    </span>
                    <span>
                      <img 
                      loading="lazy"
                      role="presentation"
                      decoding="async"
                      fetchpriority="high"src="assets/img/account/06.jpg" alt="" />
                    </span>
                  </div>
                  <div className="hero-info-content">
                    <h6>
                      <span>10k+</span> Candidates
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-xl-6">
            <div className="hero-right">
              <div className="hero-img">
                <img 
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high"src="assets/img/hero/hero-2.png" alt="" />
                <div className="hero-img-shape">
                  <img 
                  loading="lazy"
                  role="presentation"
                  decoding="async"
                  fetchpriority="high"src="assets/img/shape/02.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-shape">
        <img 
        loading="lazy"
        role="presentation"
        decoding="async"
        fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
        <img 
        loading="lazy"
        role="presentation"
        decoding="async"
        fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
        <img 
        loading="lazy"
        role="presentation"
        decoding="async"
        fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
        <img 
        loading="lazy"
        role="presentation"
        decoding="async"
        fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
      </div>
    </div>
  </div>
  

  )
}
export default HeroSection
